class MainSearchForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="q"]');
    this.clear = this.querySelector("[data-clear]");

    if (!this.input) return;

    this.toggleClearVisibility();

    this.input.addEventListener("input", () => {
      this.toggleClearVisibility();
    });

    this.clearValue = () => {
      this.input.value = "";
      this.toggleClearVisibility();
    };

    const handleClear = () => {
      this.clearValue();
      this.input.focus();
    };

    this.clear?.addEventListener("click", handleClear);
  }

  disconnectedCallback() {}

  toggleClearVisibility() {
    this.toggleAttribute("active", this.input.value.length > 0);
  }
}

if (!customElements.get("main-search-form")) {
  customElements.define("main-search-form", MainSearchForm);
}
